<template>
    <div class="lds-widget-card__approved">
        <template v-if="offerName">
            {{ offerName }}
            <span
                class="lds-widget-card__approved-from"
                v-if="paramName"
            >{{ paramName }}
                <span class="lds-widget-card__approved-percent">{{ paramValue }} %</span>
            </span>
        </template>
    </div>
</template>

<script setup>
/* миг кеш одобряет от 98% */
defineProps({
    offerName: {
        type: [String, null],
        required: true,
    },
    paramName: {
        type: String,
        default: '',
    },
    paramValue: {
        type: [String, Number],
        default: '',
    },
});
</script>
<style lang="scss" scoped>
@import '../../assets/styles/design1/offer';
</style>